import { IconCalendar, IconCalendarEvent, IconCategory, IconClipboardList, IconClockHour10, IconCreditCard, IconCurrencyDollar, IconDoor, IconExternalLink, IconGlobe, IconHome, IconLayoutDashboardFilled, IconLock, IconMessage, IconPackage, IconPlugConnected, IconReport, IconSettings, IconShield, IconUsers, IconUsersGroup, IconWorldCog } from "@tabler/icons-react";
import { NAVIGATION_URLS } from "./urls";

export const NAV_LINKS = [
    { name: 'Dashboard', href: NAVIGATION_URLS.DASHBOARD, icon: IconLayoutDashboardFilled, roles: [] },
    {
        name: 'Front Office',
        href: NAVIGATION_URLS.DASHBOARD_ADMIN_RESERVATION,
        icon: IconCalendarEvent,
        permissions: [
            'booking_view',
            'calendar_view',
            'agent_view',
            'room_maintenance_view',
            'pms_report_view',
            'pms_report_occupancy_report',
            'pms_report_agent_report',
            'pms_report_revenue_report',
            'pms_report_sales_report',
            'pms_report_property_report',
            'pms_report_group_report',
            'pms_report_growth_report',
            'pms_report_room_report',
            'pms_log',
            'housekeeping_view',
            'booking_extra'
        ],
        child: [
            // { name: 'Dashboard', href: NAVIGATION_URLS.DASHBOARD_ADMIN_RESERVATION_DASHBOARD, icon: IconDashboard },
            { name: 'Booking List', href: NAVIGATION_URLS.DASHBOARD_ADMIN_RESERVATION, icon: IconClipboardList, permissions: ['booking_view'] },
            { name: 'Calendar', href: NAVIGATION_URLS.DASHBOARD_ADMIN_RESERVATION_CALENDAR, icon: IconCalendar, permissions: ['calendar_view'] },
            { name: 'Agent Settings', href: NAVIGATION_URLS.DASHBOARD_ADMIN_RESERVATION_AGENT_SETTINGS, icon: IconCreditCard, permissions: ['agent_view'] },
            { name: 'Room Maintenance', href: NAVIGATION_URLS.DASHBOARD_ADMIN_RESERVATION_ROOM_MAINTENANCE, icon: IconDoor, permissions: ['room_maintenance_view'] },
            { name: 'Reports', href: NAVIGATION_URLS.DASHBOARD_ADMIN_RESERVATION_REPORTS, icon: IconReport, permissions: ['pms_report_view', 'pms_report_occupancy_report', 'pms_report_agent_report', 'pms_report_revenue_report', 'pms_report_sales_report'] },
            { name: 'Log', href: NAVIGATION_URLS.DASHBOARD_ADMIN_RESERVATION_LOG, icon: IconClockHour10, permissions: ['pms_log'] },
            { name: 'Housekeeping', href: NAVIGATION_URLS.DASHBOARD_ADMIN_RESERVATION_HOUSEKEEPING, icon: IconClipboardList, permissions: ['housekeeping_view'] },
            { name: 'Extra', href: NAVIGATION_URLS.DASHBOARD_ADMIN_INVENTORY_ITEMS, icon: IconPackage, permissions: ['booking_extra'] },
            { name: 'Extra Category', href: NAVIGATION_URLS.DASHBOARD_ADMIN_INVENTORY_CATEGORIES, icon: IconCategory, permissions: ['booking_extra'] }
        ]
    },
    {
        name: 'Channel Manager',
        href: NAVIGATION_URLS.DASHBOARD_ADMIN_CHANNEL_MANAGER,
        icon: IconGlobe,
        permissions: [
            'monthly_setup_view',
            'channel_setup',
            'room_rate_view',
            'cm_report_view',
            'cm_report_property_report',
            'cm_report_group_report',
            'cm_report_growth_report',
            'cm_report_room_report',
            'message_view',
            'icalendar_view',
            'review_view'
        ],
        child: [
            { name: 'Rates & Availabilities', href: NAVIGATION_URLS.DASHBOARD_ADMIN_CHANNEL_MANAGER_MONTHLY_SETUP, icon: IconSettings, permissions: ['monthly_setup_view'] },
            { name: 'Channel Setup', href: NAVIGATION_URLS.DASHBOARD_ADMIN_CHANNEL_MANAGER_CHANNEL_SETUP, icon: IconWorldCog, permissions: ['channel_setup'], disabledWhenPropertyInactive: true },
            { name: 'Room & Rate Settings', href: NAVIGATION_URLS.DASHBOARD_ADMIN_PROPERTY_SETTINGS_RATE, icon: IconCurrencyDollar, permissions: ['room_rate_view'] },
            { name: 'iCalendar', href: NAVIGATION_URLS.DASHBOARD_ADMIN_CHANNEL_MANAGER_ICALENDAR, icon: IconCalendar, permissions: ['icalendar_view'], disabledWhenPropertyInactive: true },
            { name: 'Message', href: NAVIGATION_URLS.DASHBOARD_ADMIN_CHANNEL_MANAGER_MESSAGE, icon: IconMessage, permissions: ['message_view'], disabledWhenPropertyInactive: true },
            { name: 'Reviews', href: NAVIGATION_URLS.DASHBOARD_ADMIN_CHANNEL_MANAGER_REVIEW, icon: IconClipboardList, permissions: ['review_view'], disabledWhenPropertyInactive: true },
            { name: 'Reports', href: NAVIGATION_URLS.DASHBOARD_ADMIN_CHANNEL_MANAGER_REPORTS, icon: IconReport, permissions: ['cm_report_view', 'cm_report_property_report', 'cm_report_group_report', 'cm_report_growth_report', 'cm_report_room_report'] },
        ]
    },
    {
        name: 'Booking Engine',
        href: '#',
        icon: IconExternalLink,
        permissions: ['booking_engine_access'],
        child: [
            { name: 'Open Booking Engine', href: 'ACTION_BOOKING_ENGINE_REDIRECT', icon: IconExternalLink, permissions: ['booking_engine_access'] }
        ]
    },
    {
        name: 'Dynamic Pricing Manager',
        href: NAVIGATION_URLS.DASHBOARD_ADMIN_DYNAMIC_PRICING_GROUP,
        icon: IconSettings,
        permissions: ['dynamic_pricing_view'],
        disabledWhenPropertyInactive: true,
        child: [
            { name: 'Set Up', href: NAVIGATION_URLS.DASHBOARD_ADMIN_DYNAMIC_PRICING_GROUP, icon: IconSettings, permissions: ['dynamic_pricing_view'], disabledWhenPropertyInactive: true },
            // { name: 'Pricing Calendar', href: NAVIGATION_URLS.DASHBOARD_ADMIN_DYNAMIC_PRICING_CALENDAR, icon: IconCalendar, permissions: ['dynamic_pricing_view'] },
        ]
    },
    {
        name: 'Property Settings',
        href: NAVIGATION_URLS.DASHBOARD_ADMIN_PROPERTY_SETTINGS,
        icon: IconSettings,
        permissions: ['property_management_view'],
        child: [
            { name: 'Property Management', href: NAVIGATION_URLS.DASHBOARD_ADMIN_PROPERTY_SETTINGS_PROPERTY_MANAGEMENT, icon: IconHome, permissions: ['property_management_view'] },
        ]
    },
    {
        name: 'Settings',
        href: NAVIGATION_URLS.DASHBOARD_ADMIN_SETTINGS_USER_MANAGEMENT,
        icon: IconSettings, // Ganti dengan ikon yang sesuai
        permissions: ['user-view', 'permission-view', 'role_view', 'property_management_view', 'billing_integration_view'],
        child: [
            { name: 'User Management', href: NAVIGATION_URLS.DASHBOARD_ADMIN_SETTINGS_USER_MANAGEMENT, icon: IconUsers, permissions: ['user-view'] },
            { name: 'Groups', href: NAVIGATION_URLS.DASHBOARD_ADMIN_SETTINGS_GROUPS, icon: IconUsersGroup, permissions: ['group_view'] },
            { name: 'Roles', href: NAVIGATION_URLS.DASHBOARD_ADMIN_SETTINGS_ROLES, icon: IconShield, permissions: ['role_view'] },
            { name: 'Permissions', href: NAVIGATION_URLS.DASHBOARD_ADMIN_SETTINGS_PERMISSIONS, icon: IconLock, permissions: ['permission-view'] },
            { name: 'Regions', href: NAVIGATION_URLS.DASHBOARD_ADMIN_SETTINGS_REGIONS, icon: IconGlobe, permissions: ['property_management_view'] },
            // Dev-only: no `permissions` here on purpose — with only `roles` set, RequireAuth uses AND semantics, so
            // the link shows ONLY for role dev (a `permissions` entry would turn it into dev OR permission).
            { name: 'Integrations', href: NAVIGATION_URLS.DASHBOARD_ADMIN_SETTINGS_INTEGRATIONS, icon: IconPlugConnected, roles: ['dev'] },
            // { name: 'System Settings', href: URLS.DASHBOARD_ADMIN_SYSTEM_SETTINGS, icon: IconSettings2 }
        ]

    }
];